import { config, hooks, mui, React, ts, ui } from '_core';

import { DraftParams } from './types';

type FormProps = {
  params: DraftParams;
  setParams: (_p: DraftParams) => void;

  startDate?: string;
  endDate?: string;
  universeId?: number;
  frequency?: ts.enums.FREQUENCY_ENUM;
};

const Form = ({ params, setParams, startDate = null, endDate = null, universeId = null, frequency }: FormProps) => {
  const uiStyles = hooks.useUiStyles();
  const [date, setDate] = React.useState(params.details_end_date || endDate);

  const [componentErrors, setComponentErrors] = React.useState([]);

  React.useEffect(() => {
    const data = {
      details_start_date: date,
      details_end_date: date,
      component_errors: componentErrors,
    };

    setParams({ ...params, ...data });
  }, [date, componentErrors]);

  return (
    <mui.core.Box sx={uiStyles.widgetEditMode}>
      <ui.SmartDateSelector
        label="Date"
        value={date}
        setValue={(date) => setDate(date)}
        minDate={startDate || config.features.start_date}
        maxDate={endDate || config.features.end_date}
        universeId={universeId}
        frequency={frequency}
        setExternalError={(e) => setComponentErrors(e ? [e] : [])}
      />
    </mui.core.Box>
  );
};

export default Form;
